import useNavigation from '@/hooks/useNavigation';

const useSearchParams = (key: string) => {
  const navigation = useNavigation();

  return navigation.query?.[key] as string | undefined;
};

export default useSearchParams;
